export default function Quote() {
  return (
    <section className="pc-bg border-y pc-line">
      <div className="mx-auto max-w-4xl px-5 lg:px-8 py-24 lg:py-32 text-center">
        <span className="inline-block tricolor-stripe !h-2.5 mb-8" aria-hidden />
        <p className="font-serif-emph text-[28px] sm:text-[40px] lg:text-[48px] leading-[1.2] tracking-[-0.025em] pc-text-ink text-balance" style={{ fontStyle: 'normal' }}>
          <span className="font-serif-emph" style={{ fontStyle: 'italic' }}>“</span>
          Vous ne nous payez jamais avant d'avoir encaissé.
          <span className="block pc-text-muted mt-3">C'est contractuel à chaque étape.<span className="font-serif-emph" style={{ fontStyle: 'italic' }}>”</span></span>
        </p>
        <div className="mt-10 hairline mx-auto max-w-[60px]" />
        <p className="text-[11.5px] tracking-[0.22em] uppercase pc-text-muted font-semibold mt-5">
          Engagement Prévention Conseil
        </p>
      </div>
    </section>
  );
}
